// import React from 'react';
// import {
//   Box,
//   Typography,
//   TextField,
//   IconButton,
//   Divider,
//   Chip,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';

// interface Tag {
//   label: string;
//   value: string;
// }

// interface BasicDetailsProps {
//   budgetName: string;
//   setBudgetName: (name: string) => void;
//   budgetDescription: string;
//   setBudgetDescription: (description: string) => void;
//   tags: Tag[];
//   handleDeleteTag: (tagToDelete: Tag) => void;
//   setIsDialogOpen: (isOpen: boolean) => void;
//   errors: { [key: string]: string };
// }

// const BasicDetails: React.FC<BasicDetailsProps> = ({
//   budgetName,
//   setBudgetName,
//   budgetDescription,
//   setBudgetDescription,
//   tags,
//   handleDeleteTag,
//   setIsDialogOpen,
//   errors,
// }) => {
//   return (
//     <Box
//       sx={{
//         p: { xs: 1, sm: 2 },
//         bgcolor: '#FFFFFF',
//         borderRadius: '10px',
//         border: '1px solid #F3F3F3',
//       }}
//     >
//       <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//         <img src="/icons/Basic-Details.svg" alt="Basic Details" style={{ marginRight: '12px', width: '28px', height: '28px' }} />
//         <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '14px', color: '#333333', fontFamily: 'Inter', lineHeight: '20px' }}>
//           Basic Details
//         </Typography>
//       </Box>
//       <Divider sx={{ borderColor: '#F3F3F3', mx: -2 }} />
//       <Box sx={{ display: 'grid', gridTemplateColumns: { sm: '1fr', md: '377px 1fr' }, gap: 3, mt: 3, px: 1 }}>
//         <Box>
//           <Typography variant="body2" sx={{ mb: 1, fontWeight: 400, fontSize: '14px', color: '#333333', fontFamily: 'Inter' }}>
//             Budget Name<span style={{ color: 'red' }}>*</span>
//           </Typography>
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder="Enter budget name"
//             size="small"
//             value={budgetName}
//             onChange={(e) => setBudgetName(e.target.value)}
//             error={!!errors.budgetName}
//             helperText={errors.budgetName}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 height: '36px',
//                 borderRadius: '8px',
//                 backgroundColor: '#FFFFFF',
//                 '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                   borderColor: '#0064FF', 
//                   borderWidth: '1px',
//                 },
//               },
//               '& .MuiInputBase-input': {
//                 fontSize: '14px',
//                 fontFamily: 'Inter',
//               },
//             }}
//           />
//         </Box>
//         <Box>
//           <Typography variant="body2" sx={{ mb: 1, fontWeight: 400, fontSize: '14px', color: '#333333', fontFamily: 'Inter' }}>
//             Budget Description<span style={{ color: 'red' }}>*</span>
//           </Typography>
//           <TextField
//             fullWidth
//             variant="outlined"
//             placeholder="Enter description here"
//             size="small"
//             value={budgetDescription}
//             onChange={(e) => setBudgetDescription(e.target.value)}
//             error={!!errors.budgetDescription}
//             helperText={errors.budgetDescription}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 height: '36px',
//                 borderRadius: '8px',
//                 backgroundColor: '#FFFFFF',
//                 '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                 borderColor: '#0064FF', 
//                 borderWidth: '1px',
//               },
//               },
//               '& .MuiInputBase-input': {
//                 fontSize: '14px',
//                 fontFamily: 'Inter',
//               },
//             }}
//           />
//         </Box>
//       </Box>

//       <Box sx={{ mt: 3, px: 1 }}>
//         <Typography variant="body2" sx={{ fontWeight: 400, fontSize: '14px', color: '#333333', fontFamily: 'Inter', mb: 1 }}>
//           Labels/ Tags<span style={{ color: 'red' }}>*</span>
//         </Typography>
//         <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
//           {tags.map((tag, index) => (
//             <Chip
//               key={index}
//               label={`${tag.label}: ${tag.value}`}
//               onDelete={() => handleDeleteTag(tag)}
//               deleteIcon={<CloseIcon />}
//               sx={{
//                 backgroundColor: ' #F3F8FE',
//                 color: '#333333',
//                 fontFamily: 'Inter',
//                 fontSize: '12px',
//                 fontWeight: 500,
//                 borderRadius: '8px',
//                 '.MuiChip-deleteIcon': {
//                   color: '#333333',
//                   fontSize: '16px',
//                 },
//               }}
//             />
//           ))}
//           <IconButton
//             onClick={() => setIsDialogOpen(true)}
//             aria-label="add tag"
//             sx={{ borderRadius: '8px', width: '32px', height: '32px' }}
//           >
//             <img src="/icons/add-filter-icon.svg" alt="Add Tag" style={{ width: '32px', height: '32px' }} />
//           </IconButton>
//         </Box>
//         {errors.tags && (
//           <Typography color="error" variant="caption" sx={{ display: 'block', mt: 1 }}>
//             {errors.tags}
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default BasicDetails;

import React from 'react';
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Divider,
  Chip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Tag {
  label: string;
  value: string;
  id: string | number;
}

interface BasicDetailsProps {
  budgetName: string;
  onBudgetNameChange: (name: string) => void;
  budgetDescription: string;
  onBudgetDescriptionChange: (description: string) => void;
  tags: Tag[];
  handleDeleteTag: (tagToDelete: Tag) => void;
  setIsDialogOpen: (isOpen: boolean) => void;
  errors: { [key: string]: string };
}

const BasicDetails: React.FC<BasicDetailsProps> = ({
  budgetName,
  onBudgetNameChange,
  budgetDescription,
  onBudgetDescriptionChange,
  tags,
  handleDeleteTag,
  setIsDialogOpen,
  errors,
}) => {
  return (
    <Box
      sx={{
        p: { xs: 1, sm: 2 },
        bgcolor: '#FFFFFF',
        borderRadius: '10px',
        border: '1px solid #F3F3F3',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <img src="/icons/Basic-Details.svg" alt="Basic Details" style={{ marginRight: '12px', width: '28px', height: '28px' }} />
        <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '14px', color: '#333333', fontFamily: 'Inter', lineHeight: '20px' }}>
          Basic Details
        </Typography>
      </Box>
      <Divider sx={{ borderColor: '#F3F3F3', mx: -2 }} />
      <Box sx={{ display: 'grid', gridTemplateColumns: { sm: '1fr', md: '377px 1fr' }, gap: 3, mt: 3, px: 1 }}>
        <Box>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 400, fontSize: '14px', color: '#333333', fontFamily: 'Inter' }}>
            Budget Name<span style={{ color: 'red' }}>*</span>
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Enter budget name"
            size="small"
            value={budgetName}
            onChange={(e) => onBudgetNameChange(e.target.value)}
            error={!!errors.budgetName}
            helperText={errors.budgetName}
            inputProps={{ maxLength: 50 }}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: '36px',
                borderRadius: '8px',
                backgroundColor: '#FFFFFF',
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#0064FF', 
                  borderWidth: '1px',
                },
              },
              '& .MuiInputBase-input': {
                fontSize: '14px',
                fontFamily: 'Inter',
              },
            }}
          />
        </Box>
        <Box>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 400, fontSize: '14px', color: '#333333', fontFamily: 'Inter' }}>
            Budget Description<span style={{ color: 'red' }}>*</span>
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Enter description here"
            size="small"
            value={budgetDescription}
            onChange={(e) => onBudgetDescriptionChange(e.target.value)}
            error={!!errors.budgetDescription}
            helperText={errors.budgetDescription}
            inputProps={{ maxLength: 200 }}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: '36px',
                borderRadius: '8px',
                backgroundColor: '#FFFFFF',
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#0064FF', 
                borderWidth: '1px',
              },
              },
              '& .MuiInputBase-input': {
                fontSize: '14px',
                fontFamily: 'Inter',
              },
            }}
          />
        </Box>
      </Box>

      <Box sx={{ mt: 3, px: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 400, fontSize: '14px', color: '#333333', fontFamily: 'Inter', mb: 1 }}>
          Labels/ Tags
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
          {tags.map((tag) => (
            <Chip
            key={tag.id}
              // key={index}
              label={`${tag.label}: ${tag.value}`}
              onDelete={() => handleDeleteTag(tag)}
              deleteIcon={<CloseIcon />}
              sx={{
                backgroundColor: ' #F3F8FE',
                color: '#333333',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 500,
                borderRadius: '8px',
                '.MuiChip-deleteIcon': {
                  color: '#333333',
                  fontSize: '16px',
                },
              }}
            />
          ))}
          <IconButton
            onClick={() => setIsDialogOpen(true)}
            aria-label="add tag"
            sx={{ borderRadius: '8px', width: '32px', height: '32px' }}
          >
            <img src="/icons/add-filter-icon.svg" alt="Add Tag" style={{ width: '32px', height: '32px' }} />
          </IconButton>
        </Box>
        {errors.tags && (
          <Typography color="error" variant="caption" sx={{ display: 'block', mt: 1 }}>
            {errors.tags}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default BasicDetails;